<template>
    <div
        style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;display: flex;flex-direction: column;background: #F5F5F5;">
        <div
            style="font-weight: 700;font-size: large;width: 100%;display: flex;align-items: center;padding-top: 20px;padding-bottom: 20px;background: white;">
            <img src="../assets/返回.png" style="width: 20px;height: 20px;margin-left: 30px;" alt="">
            <div style="flex: 1;">修改地址</div>
            <div style="width: 50px;"></div>
        </div>
        <div style="width: 90%;margin-top: 20px;">
            <el-form ref="form" :model="addForm" label-width="80px">
                <el-form-item label="联系人">
                    <div style="display: flex;align-items: center;">
                        <el-input v-model="addForm.contact"></el-input>
                        <div style="width: 30px;"></div>
                    </div>

                </el-form-item>
                <el-form-item label="性别">
                    <div style="display: flex;align-items: center;">
                        <el-radio-group v-model="addForm.sex">
                            <el-radio-button :label="1">先生</el-radio-button>
                            <el-radio-button :label="2">女士</el-radio-button>
                        </el-radio-group>
                    </div>

                </el-form-item>
                <el-form-item label="电话">
                    <div style="display: flex;align-items: center;">
                        <el-input v-model="addForm.phoneNumber"></el-input>
                        <div style="width: 30px;"></div>
                    </div>

                </el-form-item>
                <el-form-item label="定位信息">
                    <div style="display: flex;align-items: center;">
                        <div @click="getLocationByGaode" style="flex: 1;">
                            <el-input v-model="addForm.location" :readonly="true"></el-input>
                        </div>

                        <img @click="getLocationByGaode" src="../assets//定位1.png" style="width: 30px;" alt="">
                    </div>

                </el-form-item>
                <el-form-item label="详细地址">
                    <div style="display: flex;align-items: center;">
                        <el-input v-model="addForm.detailAddress"></el-input>
                        <div style="width: 30px;"></div>
                    </div>

                </el-form-item>
                <el-form-item label="用户类型">
                    <div style="display: flex;align-items: center;">
                        <el-radio-group v-model="addForm.type">
                            <el-radio-button :label="1">商户</el-radio-button>
                            <el-radio-button :label="2">居民</el-radio-button>
                            <el-radio-button :label="3">机构</el-radio-button>
                        </el-radio-group>
                    </div>

                </el-form-item>
            </el-form>
        </div>
         <div style="width: 100%;margin: 20px 0;" :style="{
            height: $store.state.indexBarHeight+10 + 'px'
        }">
            <a href="https://beian.miit.gov.cn/" target="_blank">ICP备案号</a>
            <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2026080515号-2</a>
        </div>
        <el-button @click="updateMyAddress" type="success"
            style="position: absolute;bottom: 20px;width: 80%;margin: 0 10%;font-size: large;">保存</el-button>

    </div>
</template>
<script>
import request from "../axios/request";
import { mapState } from "vuex";
export default {
    data() {
        return {
            id: null
        }
    },
    computed: {

        ...mapState(['addForm']),
    },
    mounted() {
        this.id = this.$route.params.id;

        if (this.addForm.id == undefined) {
            this.getAddressInfoById()
        }

    },

    methods: {
        async updateMyAddress() {
            let res = await request({
                url: "/address/api/updateAddress",
                method: "POST",
                data: this.addForm
            })
            if (res.data.status == 200) {
                this.$router.push({
                    path: '/address'
                })
            }
        },
        async getAddressInfoById() {
            let res = await request({
                url: "/address/api/getAddressInfoById/" + this.id,
                method: "GET"
            })
            if (res.data.status == 200) {
                this.$store.state.addForm = res.data.data
            }
        },
        getLocationByGaode() {
            this.$router.push({
                path: '/gaodeLocation'
            })
        }
    }
}
</script>
<style></style>